import { createContext, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const BackofficeCtx = createContext(null);

export function useBackoffice() {
  return useContext(BackofficeCtx);
}

export default function BackofficeRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      localStorage.removeItem("hub_session");
    }
  }, [user, loading]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return (
    <BackofficeCtx.Provider value={{ role: user.role }}>
      {children}
    </BackofficeCtx.Provider>
  );
}
